module.exports = __webpack_public_path__ + "media/images/top/qa/img_step-6487716df7e76155fd282d7850b1b15d.png";